/** Stable save receipts also work on HTTP hosts where randomUUID is unavailable. */
export function createSaveRequestKey(): string {
    return crypto.randomUUID?.() ?? Array.from(crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, '0')).join('');
}
